import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { GameIntroContent } from '../../models/game-section.model';
import { GameVideoEmbedComponent } from '../../components/game-video-embed/game-video-embed.component';

@Component({
  selector: 'app-game-intro',
  imports: [GameVideoEmbedComponent],
  templateUrl: './game-intro.component.html',
  styleUrl: './game-intro.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class GameIntroComponent {
  content = input.required<GameIntroContent>();
  gameName = input.required<string>();
  mode = input<'what-is' | 'how-to-play'>('what-is');
}
